const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');

const requestAccountCheques = (accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUES_REQUEST,
    payload: {
        accountId
    }
});

const requestAccountChequesSuccess = (data, accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUES_SUCCESS,
    payload: {
        accountId,
        cheques: get(data, 'listaTalonario.datoTalonario', []),
        nextPage: get(data, '_links.nextPage.href', '')
    }
});

const requestAccountChequesFailure = (error, accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_CHEQUES_FAILURE,
    payload: {
        accountId,
        error
    }
});

function getAccountCheques(dispatch, immAccount, accountId){
    const product = immAccount.get('product');
    const contractNumber = immAccount.get('contractNumber');
    const requestData = {
        query: {
            producto: product,
            numeroContrato: contractNumber
        }
    };

    dispatch(requestAccountCheques(accountId));
    return APIGet({
        dispatch,
        endpoint: 'accountCheques',
        url: apiURLBuilder.getURL('accountCheques'),
        params: requestData
    })
    .then(response => dispatch(requestAccountChequesSuccess(response, accountId)))
    .catch( response => {
        if (!!response.error) {
            dispatch(requestAccountChequesFailure(response.error, accountId))
        } else {
            throw response;
        }
    })
}

function requestCheques(accountId) {
    return function(dispatch, getState) {
        const immAccount = getState().accounts.get('byId').get(accountId);
        return getAccountCheques(dispatch, immAccount, accountId);
    }
}

module.exports = {
    requestCheques,
    getAccountCheques
}
